import React from 'react'

export default function Video(props) {
  return (
    <div className='video-card'>
      <div className='video-thumbnail'>
        <img src={props.video.snippet.thumbnails.high.url} alt={props.video.snippet.title} />
      </div>
      <div className='video-info'>
        <h6 className='center yellowtext'>{props.video.snippet.title}</h6>
        </div>  
    </div>
  )
}
